import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BillingAddress } from "app/models/customer.model";
import { Observable } from "rxjs";
import { environment } from "environments/environment";

@Injectable()
export class CustomerService {
  private apiUrl = environment.apiUrl;
  constructor(
    private httpClient: HttpClient,
  ) {}
  
  standardizeAddress(billingAddress: BillingAddress) :Observable<any> {
    const request = {
      "Company": billingAddress.Address.Company,
      "Street1": billingAddress.Address.PostalAddress.Line1,
      "Street2": billingAddress.Address.PostalAddress.Line2,
      "Street3": "",
      "City": billingAddress.Address.PostalAddress.City,
      "StateCode": billingAddress.Address.PostalAddress.StateCode,
      "CountryCode": "US",
      "PostalCode": billingAddress.Address.PostalAddress.PostalCode
    }

    return this.httpClient.post<any>('ocmapi/standardize-address', request);    
  }     

  saveBillingAddress(billingAddress: BillingAddress): Observable<any> {  
    return this.httpClient.post<any>('ocmapi/addBilling', billingAddress);
  }

  fetchSubscriptions(customerNumber: string, productCodes: string[]): Observable<any> {
    const request ={"CustomerNumber": customerNumber, "ProductCodes":productCodes}
    return this.httpClient.post<any>('ocmapi/customerSubscriptions', request);
  }

  getInvitedUsers(agreementId:string, type:string): Observable<any> {
    const request = {AgreementId: agreementId, Type:type}
    return this.httpClient.post<any>('/ocmapi/getInvitedUsers', request);
  }

  renewSubscription(agreementId:string) {
    const request ={"AgreementId": agreementId, "OrderSource":"OCMWEB"}
    return this.httpClient.post<any>('ocmapi/renew-as-original', request);

  }
}